var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBellRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EAF8F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E6F6EE",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3544 37C26.0596 37.6224 26.9858 38 28.0002 38C29.0147 38 29.9409 37.6224 30.6461 37M18.2941 21.8199C18.2798 20.3685 19.0623 19.0132 20.3264 18.3M37.7024 21.8199C37.7167 20.3686 36.9342 19.0133 35.6702 18.3M34.0002 24C34.0002 22.4087 33.3681 20.8826 32.2429 19.7574C31.1177 18.6321 29.5915 18 28.0002 18C26.4089 18 24.8828 18.6321 23.7576 19.7574C22.6324 20.8826 22.0002 22.4087 22.0002 24C22.0002 27.0902 21.2207 29.206 20.3499 30.6054C19.6154 31.7859 19.2481 32.3761 19.2616 32.5408C19.2765 32.7231 19.3151 32.7926 19.462 32.9016C19.5947 33 20.1928 33 21.3891 33H34.6114C35.8077 33 36.4058 33 36.5385 32.9016C36.6854 32.7926 36.724 32.7231 36.7389 32.5408C36.7524 32.3761 36.3851 31.7859 35.6506 30.6054C34.7798 29.206 34.0002 27.0902 34.0002 24Z",
    stroke: "#05954E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBellRing);
export default __webpack_public_path__ + "static/media/circle_bell_ring.77e4aba768dcaafb9818ea76c7ee2450.svg";
export { ForwardRef as ReactComponent };